import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/back_to_top_new.svg';
const BackToTopSvgNew = () => React.createElement(IconSvg, null);
BackToTopSvgNew.Enhance = () => React.createElement(IconSvg, null);
export default BackToTopSvgNew;
